import classNames from 'classnames';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import useTask from '../../../../modules/tasks/hooks/use-task';
import './style.scss';

type Props = {
    onComplete?: () => void
}

const DATA: { id: string, text: string, result?: boolean }[] = [
    {
        id: 'q0',
        text: 'Julian Tuwim cierpiał na agorafobię, czyli lęk przed przebywaniem na otwartej przestrzeni.',
        result: true
    },
    {
        id: 'q1',
        text: 'Olga Tokarczuk, laureatka Literackiej Nagrody Nobla, jest wegetarianką.',
        result: true
    },
    {
        id: 'q2',
        text: 'Wisława Szymborska uwielbiała jeść fast foody.',
        result: true
    },
    {
        id: 'q3',
        text: 'Tadeusz Boy-Żeleński był kardiochirurgiem.'
    },
    {
        id: 'q4',
        text: 'Henryk Sienkiewicz miał 184 cm wzrostu.'
    },
    {
        id: 'q5',
        text: 'Stanisław Lem ukończył studia medyczne.',
        result: true
    },
    {
        id: 'q6',
        text: 'Jan Brzechwa w czasie II wojny światowej pracował jako sanitariusz.',
        result: false
    }
]

const Task103: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const { task } = useTask('t-103');

    const { register, watch } = useForm();

    const formData = watch();

    useEffect(() => {
        const isValid = DATA.every(q => {
            if (q.result) {
                return formData[q.id] === 'true';
            } else {
                return formData[q.id] === 'false';
            }
        })

        if (isValid) {
            if (completeCallback) {
                completeCallback();
            }
        }
    }, [formData, completeCallback]);

    return <div className="task task-103">
        <h2>zadanie 3</h2>
        <h3>{task?.title}</h3>
        <p>
            Czy wiecie, że Agatha Christie, brytyjska autorka powieści kryminalnych, w czasie I i II wojny pracowała w aptece? A Marek Hłasko był hipochondrykiem, czyli osobą przekonaną o tym, że jest poważnie chora bez żadnych podstaw medycznych?
        </p>
        <p className="instruction">
            <strong>Zadanie:</strong> Przeczytajcie poniższe stwierdzenia. Czy Waszym zdaniem są prawdziwe? A może fałszywe? Zaznaczcie prawidłową odpowiedź!
        </p>
        <div className="true-false">
            {
                DATA.map((q) => {
                    const trueClasses = classNames({
                        true: true,
                        checked: formData[q.id] === 'true',
                        correct: q.result
                    });
                    const falseClasses = classNames({
                        false: true,
                        checked: formData[q.id] === 'false',
                        correct: !q.result
                    });

                    return <div className="true-false-item" key={q.id}>


                        <p>
                            {q.text}
                        </p>
                        <div className="answers">
                            <label className={trueClasses}>
                                <input type="radio" value="true" {...register(q.id)} /> Prawda
                            </label>
                            <label className={falseClasses}>
                                <input type="radio" value="false" {...register(q.id)} /> Fałsz
                            </label>
                        </div>
                    </div>
                })
            }
        </div>
    </div>
}

export default Task103;
